import {ModalContext} from 'app/app';
import axios from 'axios';
import {ViewContext} from 'components/lib';
import {useState} from 'react';
import {useEffect} from 'react';
import {useContext} from 'react';
import {Fragment} from 'react';
import {useParams} from 'react-router-dom';
import styles from "./styles.module.scss";

const bindIssue = [
  {value: "Bind Pending Signatures and/or Down Payment"},
  {value: "UW Declined"},
  {value: "CW Needs to Issue Policy Manually"},
  {value: "Address in Wrong State"},
  {value: "Major Violation by One or More Drivers"},
  {value: "MVR No Hit"},
  {value: "MVR Not Matching"},
  {value: "UW Review"},
  {value: "Cover Badger Review"},
  {value: "Ineligible Cargo"},
  {value: "Ineligible Operation"},
  {value: "FMCSA Scores High"},
  {value: "Too Many Cancellations"},
  {value: "Insured Does Home Deliveries"},
  {value: "Insured Visits Construction Sites"},
  {value: "Insured Shares Vehicles, Drivers and Equipment"},
  {value: "Insured Needs to make payment"},
  {value: "Pre-Bind Docs Signatures pending"},
  {value: "Proof of Prior Insurance"},
  {value: "Post-Bind Docs Signatures Pending"},
  {value: "Connect ELD"},
  {value: "Provide 3 years of Loss Runs (AL Only)"},
  {value: "Other"},
];

export default function AddBindRequestIssuesModal() {
  const {id} = useParams();
  const {modal, setModal} = useContext(ModalContext);
  const context = useContext(ViewContext);
  const [bindReqData, setBindReqData] = useState(null);
  const [selectedIssues, setSelectedIssues] = useState([]);

  async function fetchBindRequestData() {
    await axios
      .get(`/api/bind-requests/admin/${id}`)
      .then(async (res) => {
        const bindResponseData = res.data.data;
        setBindReqData(bindResponseData);
        if (bindResponseData && bindResponseData.issues) {
          setSelectedIssues(bindResponseData.issues);
        }
      })
      .catch((err) => {
        console.log(err);
        context.notification.show(
          'Something went wrong!',
          'error',
          true,
          'toast',
          'x-circle'
        );
        setModal('');
      });
  }

  useEffect(() => {
    if (id) {
      fetchBindRequestData();
    } else return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleIssueChange = (issue) => {
    setSelectedIssues((prevSelectedIssues) => {
      const issueObject = {value: issue};
      if (prevSelectedIssues.some((i) => i.value === issue)) {
        return prevSelectedIssues.filter((i) => i.value !== issue);
      } else {
        return [...prevSelectedIssues, issueObject];
      }
    });
  };

  const handleSaveClick = async () => {
    if (selectedIssues.length === 0) {
      context.notification.show(
        'Please select at least one issue before continuing.',
        'error',
        true,
        'toast',
        'x-circle'
      );
      return;
    } else {
      try {
        const updatedIssues = selectedIssues.map((issue) => {
          const existingIssue = bindReqData.issues.find(
            (i) => i.value === issue.value
          );
          return existingIssue
            ? {
              ...existingIssue,
              solved: issue.solved || existingIssue.solved,
            }
            : issue;
        });

        const response = await axios.put(`/api/bind-requests/${id}`, {
          issues: updatedIssues,
        });

        if (response.status !== 200) {
          throw new Error('Failed to update bind request issue');
        }

        setBindReqData((prevData) => ({
          ...prevData,
          issues: updatedIssues,
        }));

        context.notification.show(
          'Issues sent successfully!',
          'success',
          true,
          'toast',
          'check-circle'
        );

        setModal('');
        window.location.reload();
      } catch (error) {
        context.notification.show(
          'There was a problem when updating the issue.',
          'error',
          true,
          'toast',
          'x-circle'
        );
      }
    }
  };

  return (
    <Fragment>
      {modal.name === "add_bind_request_issue_modal" && (
        <div className={styles.background}>
          <div className={styles.wrapper} style={{maxHeight: "90vh"}}>
            <div className={styles.insideWrapper}>
              <div
                style={{
                  fontStyle: "normal",
                  fontSize: 22,
                  marginBottom: 10,
                  marginLeft: 20,
                  color: "black"
                }}
              >
                Add new issues that need to be addressed:
              </div>
              <div className={styles.issuesContainer}>
                {bindIssue.map((issue, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "10px 0",
                      borderBottom: index !== bindIssue.length - 1 ? "1px solid #ccc" : "none"
                    }}
                  >
                    <input
                      type="checkbox"
                      id={`issue-${index}`}
                      name="bindIssues"
                      value={issue.value}
                      checked={selectedIssues.some((i) => i.value === issue.value)}
                      onChange={() => handleIssueChange(issue.value)}
                    />
                    <label htmlFor={`issue-${index}`} style={{marginLeft: 8}}>
                      {issue.value}
                    </label>
                  </div>
                ))}
              </div>
              <div className={styles.footer} style={{justifyContent: "end", paddingRight: '8px'}}>
                <div className={styles.buttons}>
                  <button className={styles.cancel} onClick={() => setModal("")}>
                    Cancel
                  </button>
                  <button
                    className={styles.save}
                    onClick={handleSaveClick}
                    disabled={modal.data.ticketStatus === "Completed"}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

